import {
  createStyles,
  makeStyles,
  OutlinedTextFieldProps,
  TextField,
  Theme,
} from "@material-ui/core";
import React from "react";

interface ColorPopTextFieldProps
  extends Omit<OutlinedTextFieldProps, "variant" | "classes"> {
  highlighted: boolean;
}

const useColorPopStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    root: {
      "& [class^='MuiOutlinedInput-input'], & [class*=' MuiOutlinedInput-input']":
        {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary.main,
          marginTop: "4px",
          borderRadius: "inherit",
        },
    },
  }),
);

/**
 * Component that renders as a standard outlined TextField by default
 * but when `highlighted` is true, it renders a filled TextField with
 * the pallette.primary.main color. Originally added for the feed
 * filter UI to make it easier to scan to see which data collection
 * components were actively being applied to the filter.
 *
 * @param props.highlighted whether to return filled (primary.main) or outlined
 * @returns
 */
export const ColorPopTextField = (props: ColorPopTextFieldProps) => {
  const { highlighted, ...rest } = props;

  const colorPopStyles = useColorPopStyles();
  return (
    <TextField
      {...rest}
      classes={highlighted ? colorPopStyles : undefined}
      variant="outlined"
    />
  );
};
